import { useForm } from "react-hook-form";
import SpinnerComponent from "../../../Loding/Spinner";
import { TranferirAtendimentoController } from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { useHistoricoContext } from "../../../../Context/Historico";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import CustomSelect from "../../Forms/LabelSelect";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState } from "react";
import { groupBy } from "../../../../Tools/ProcessingTools";
import { RetornarUsuarioResponsavelEAcompanhamentoController } from "../../../../Controllers/AssistenciaTecnica/GestaoDeAtendimento/GestaoDeAtendimentoController";
import OrSpinner from "../../../Utils/OrSpinner";
import { ListarUsuariosTransferenciaController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Loding/SpinnerPadrao";

interface ITransferirAtendimentoProps {
    ID_CASO: number;
    setShow: (show: boolean) => void;
    update: () => void;

    ID_USUARIO?: number;
    ID_USUARIO_ACOMPANHAMENTO?: number | undefined;
    ID_TIPO_CASO: number;
}

export default function TransferirAtendimento(
    props: ITransferirAtendimentoProps
) {
    const {
        value: UsuarioResponsavelEAcompanhamento,
        loading: UsuarioResponsavelEAcompanhamentoLoading,
    } = useAsyncEffect(async () => {
        if (
            props.ID_USUARIO === undefined ||
            props.ID_USUARIO_ACOMPANHAMENTO === undefined
        ) {
            return RetornarUsuarioResponsavelEAcompanhamentoController(
                props.ID_CASO
            );
        }
    }, []);

    const idUsuario =
        props.ID_USUARIO ??
        UsuarioResponsavelEAcompanhamento?.IdUsuarioResponsavel;
    const idUsuarioAcompanhamento =
        props.ID_USUARIO_ACOMPANHAMENTO ??
        UsuarioResponsavelEAcompanhamento?.IdUsuarioAcompanhamento;

    return (
        <OrSpinner
            loading={UsuarioResponsavelEAcompanhamentoLoading}
            spinner={"capys"}
        >
            <TransferirAtendimentoComponent
                {...props}
                ID_USUARIO={idUsuario ?? 0}
                ID_USUARIO_ACOMPANHAMENTO={idUsuarioAcompanhamento ?? 0}
            />
        </OrSpinner>
    );
}

function TransferirAtendimentoComponent(
    props: Required<ITransferirAtendimentoProps>
) {
    const { register, handleSubmit, reset } =
        useForm<Required<ITransferirAtendimentoProps>>();
    const { value: lstUsuarios, loading: lstUsuariosLoading } =
        useAsyncEffect(async () => {
            return ListarUsuariosTransferenciaController({
                DS_STATUS_USUARIO: "Ativos",
                FL_ATENDIMENTO_ABERTO: true,
                ID_TIPO_CASO: props.ID_TIPO_CASO,
            }).then((res) => {
                return res.map((ua) => ({
                    ...ua,
                    ATENDIMENTOS: Array.from(
                        groupBy(ua.ATENDIMENTOS, (a) =>
                            a.ID_TIPO_CASO?.toString()
                        ).values()
                    ).map((as) => ({
                        ...as[0],
                        NR_ATENDIMENTOS_ABERTOS: as.reduce(
                            (sum, a) => sum + (a.NR_ATENDIMENTOS_ABERTOS ?? 0),
                            0
                        ),
                    })),
                }));
            });
        }, []);
    const [idUsuario, setIdUsuario] = useState(props.ID_USUARIO);
    const { ReloadHistorico } = useHistoricoContext();

    const {
        execute: TranferirAtendimento,
        loading: TranferirAtendimentoLoading,
    } = useAsyncCallback(TranferirAtendimentoController);

    function handleTransferirFormSubmit(
        formData: Required<ITransferirAtendimentoProps>
    ) {
        TranferirAtendimento({
            ...formData,
            ID_USUARIO_TRANSFERIR: idUsuario,
            ID_CASO: props.ID_CASO,
        }).then(() => {
            props.setShow(false);
            props.update();
            reset();
            if (ReloadHistorico) ReloadHistorico();
        });
    }

    return (
        <div>
            {lstUsuarios ? (
                <form onSubmit={handleSubmit(handleTransferirFormSubmit)}>
                    <div className="form-group">
                        <label htmlFor="ID_USUARIO_TRANSFERIR">
                            Transferir para usuário:
                        </label>
                        <CustomSelect
                            value={idUsuario}
                            onChange={setIdUsuario}
                            options={lstUsuarios}
                            getKeyValue={(u) => u.ID_USUARIO ?? 0}
                            optionRender={(u) => {
                                const atendimentos = u.ATENDIMENTOS.reduce(
                                    (sum, ua) =>
                                        sum + (ua.NR_ATENDIMENTOS_ABERTOS ?? 0),
                                    0
                                );
                                return (
                                    <div className="w-100 d-flex justify-content-between align-items-center">
                                        <span>{u.DS_NOME}</span>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    className="z-index-1500"
                                                    id="tooltip"
                                                >
                                                    {
                                                        u.ATENDIMENTOS[0]
                                                            ?.DS_TIPO_CASO
                                                    }{" "}
                                                    - {atendimentos} <br />
                                                </Tooltip>
                                            }
                                        >
                                            <span className="label label-rounded label-success">
                                                {atendimentos}
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                );
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ID_USUARIO_ACOMPANHAMENTO">
                            Acompanhamento do atendimento:
                        </label>
                        <select
                            className="form-control"
                            name="ID_USUARIO_ACOMPANHAMENTO"
                            defaultValue={props.ID_USUARIO_ACOMPANHAMENTO}
                            ref={register({
                                valueAsNumber: true,
                            })}
                        >
                            <option></option>
                            {lstUsuarios.map((usuario) => (
                                <option
                                    value={usuario.ID_USUARIO}
                                    key={usuario.ID_USUARIO}
                                >
                                    {usuario.DS_NOME}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button
                        className="btn btn-success col-12"
                        type="submit"
                        disabled={
                            lstUsuariosLoading || TranferirAtendimentoLoading
                        }
                    >
                        {lstUsuariosLoading || TranferirAtendimentoLoading ? (
                            <Spinner color="primary" size="sm" />
                        ) : (
                            "Transferir"
                        )}
                    </button>
                </form>
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
